import { render, staticRenderFns } from "./ModalAddress.vue?vue&type=template&id=5cfaffee&"
import script from "./ModalAddress.vue?vue&type=script&lang=js&"
export * from "./ModalAddress.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddress.vue?vue&type=style&index=0&id=5cfaffee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports